export const ThumbnailPreview = {
  mounted() {
    const input = this.el.querySelector("input[type='file']") as HTMLInputElement | null
    const img = this.el.querySelector("#thumbnail-preview-img") as HTMLImageElement | null
    const placeholder = this.el.querySelector("#thumbnail-placeholder") as HTMLElement | null

    if (!input || !img) return

    let objectUrl: string | null = null

    input.addEventListener("change", () => {
      const file = input.files?.[0]
      if (!file) return

      if (objectUrl) URL.revokeObjectURL(objectUrl)
      objectUrl = URL.createObjectURL(file)

      img.src = objectUrl
      img.style.display = "block"
      if (placeholder) placeholder.style.display = "none"

      // Also sync to the review step image if it exists
      const reviewImg = document.getElementById("thumbnail-review-img") as HTMLImageElement | null
      if (reviewImg) {
        reviewImg.src = objectUrl
        reviewImg.style.display = "block"
      }
    })
  },
}

// Syncs the review-step thumbnail from the step-4 preview ObjectURL when mounted
export const ThumbnailReviewSync = {
  mounted() {
    const previewImg = document.getElementById("thumbnail-preview-img") as HTMLImageElement | null
    if (previewImg && previewImg.src && previewImg.src !== window.location.href) {
      this.el.src = previewImg.src
      this.el.style.display = "block"
    }
  },
}
